import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userGroups: [],
    userData: {},
    personalCabinetData: null,
  },
  mutations: {
    setUserGroups(state, payload) {
      state.userGroups = payload
      localStorage.setItem('userGroups', JSON.stringify(payload))
    },
    setUserData(state, payload) {
      state.userData = payload
    },
    setPersonalCabinetData(state, payload) {
      state.personalCabinetData = payload
    },
  },
  actions: {},
  modules: {},
})
